import {FC} from "react";
import {Box, Link} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {useGetUserActivePlaylists, type UserActivePlaylistDto} from "@/app2/shared/data";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

interface UserActivePlaylistsTabProps {
	userId: number;
}

/**
 * Admin view of a learner's in-progress playlist enrollments (shell rows).
 */
export const UserActivePlaylistsTab: FC<UserActivePlaylistsTabProps> = ({userId}) => {
	const {data, isLoading} = useGetUserActivePlaylists(userId);

	const columns: GridColDef<UserActivePlaylistDto>[] = [
		{
			field: "title",
			headerName: "Playlist",
			flex: 1,
			minWidth: 220,
			renderCell: (params) => (
				<Link
					component={RouterLink}
					to={`/admin/playlists/${params.row.playlistId}/courses`}
					color="inherit"
					underline="hover"
				>
					{params.row.title || `Playlist ${params.row.playlistId}`}
				</Link>
			)
		},
		{
			field: "assignedOn",
			headerName: "Assigned on",
			flex: 1,
			valueFormatter: (p) => {
				if (!p.value) return "—";
				return new Date(p.value as string).toLocaleDateString();
			}
		},
		{
			field: "dueOn",
			headerName: "Due on",
			flex: 1,
			valueFormatter: (p) => {
				if (!p.value) return "—";
				return new Date(p.value as string).toLocaleDateString();
			}
		},
		{
			field: "enrollmentType",
			headerName: "Enrollment type",
			flex: 1,
			valueFormatter: (p) => ((p.value as string) || "—").replace(/-/g, " ")
		},
		// {
		// 	field: "progress",
		// 	headerName: "Progress",
		// 	flex: 1,
		// 	renderCell: (params) => {
		// 		const progress = params.value != null ? Math.round(Number(params.value)) : null;
		// 		if (progress == null || Number.isNaN(progress)) {
		// 			return <Typography variant="caption">—</Typography>;
		// 		}
		// 		return (
		// 			<Stack direction="row" alignItems="center" spacing={1} sx={{width: "100%"}}>
		// 				<LinearProgress
		// 					variant="determinate"
		// 					value={Math.min(100, Math.max(0, progress))}
		// 					sx={{flexGrow: 1, height: 8, borderRadius: 4}}
		// 				/>
		// 				<Typography variant="caption" sx={{minWidth: 36}}>
		// 					{progress}%
		// 				</Typography>
		// 			</Stack>
		// 		);
		// 	}
		// }
	];

	return (
		<Box>
			<DataGridPro
				rows={data?.data ?? []}
				columns={columns}
				loading={isLoading}
				getRowId={(row) => row.enrollmentId}
				rowsPerPageOptions={[25, 50, 100, 200]}
				initialState={{
					pagination: {pageSize: 25},
					sorting: {sortModel: [{field: "assignedOn", sort: "desc"}]}
				}}
				autoHeight
				sx={{
					"& .MuiDataGrid-row": {cursor: "default"}
				}}
			/>
		</Box>
	);
};
